/**
 * ExpiringShareRow — single row in Dashboard Expiring-Shares-Section.
 * Sprint B PR-B3 DK-19.
 *
 * Info-only (kein inline-Revoke per spec OOS). Click-through navigiert zum
 * Asset/Collection-Detail wo der existing ShareModal-flow Revoke/Recreate macht.
 *
 * Countdown-Format (`formatExpiryCountdown`) lebt in `lib/format-expiry-countdown.ts`
 * (react-refresh/only-export-components: Component-Files exportieren nur Components).
 */
import { Link } from 'wouter';
import type { ExpiringShare } from '../../shared/dashboard-types';
import { I } from '../lib/icons';
import { formatExpiryCountdown } from '../lib/format-expiry-countdown';

export function ExpiringShareRow({ share }: { share: ExpiringShare }) {
  const href =
    share.targetType === 'asset'
      ? `/assets/${share.targetId}`
      : `/collections/${share.targetId}`;
  const TypeIcon = share.targetType === 'asset' ? I.image : I.tv;

  return (
    <Link
      href={href}
      className="flex items-center gap-3 px-3 py-2 rounded-md hover:bg-ink-50 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green-700"
    >
      {/* Fainter brand-yellow Icon-Chip (P2 2026-06-10): ablaufende Share-Links
          sind ein mildes Dringlichkeits-Signal — der gelbe Chip hebt sie vom
          neutral-grünen Activity-Feed ab (Von-Restorff) und nutzt das brand-
          yellow, das sonst nirgends strukturell vorkommt. Bewusst /20 (zart) +
          dunkleres grün-700-Icon für Lesbarkeit; bleibt in der 5-Farben-Palette. */}
      <div className="w-9 h-9 rounded bg-brand-yellow/20 flex items-center justify-center flex-shrink-0 text-brand-green-700">
        <TypeIcon size={16} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-medium text-brand-green-700 truncate">
          {share.targetName}
        </div>
        <div className="text-xs2 text-brand-green-600 truncate">
          {formatExpiryCountdown(share.expiresAt)} · von {share.createdByDisplayName}
        </div>
      </div>
    </Link>
  );
}
